import {otsBaseApi} from "../../ots-api";
import {
    ContainerDNUStatisticsSnapshot,
    ContainerDNUStatisticsSnapshotEntity
} from "../../../model/container-dnu-statistics-snapshot";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ContainerDNUStatistics"]});

export const containerDNUStatisticsApi = taggedBaseApi.injectEndpoints({
    endpoints: (builder) => ({
        searchContainerDNUStatistics: builder.query<ContainerDNUStatisticsSnapshot[], ContainerDNUStatisticsSnapshotEntity>({
            query: (arg) => ({
                url: `/statistics/container-dnu/search`,
                method: "POST",
                body: arg
            }),
            providesTags: (result, _error, arg, _meta) => {
                return [{type: "ContainerDNUStatistics", id: "LIST"}];
            },
        }),
    })
});

export const {
    useSearchContainerDNUStatisticsQuery,
} = containerDNUStatisticsApi;
